import FlexBox from '@/atomic-components/FlexBox';
import PDPDrawer from './Components/PdpDrawer';
import CrossIcon from '../../assets/pdp/crossIcon.svg';
import { Box, Drawer } from '@mui/material';
import { getColor } from '@/utils/theme/colors';
import { getStyle } from '@/utils/theme/fonts';
import { useEffect } from 'react';
import { emitMoeEvent } from '@/utils/dataLayer';

type ExtraFeaturesDrawerProps = {
	icon?: any;
	label?: string;
	description?: string;
	data?: any;
	setOpenExtraFeatureDrawer: () => void;
	openDrawerToSeeDescription: boolean;
};

const ExtraFeaturesDrawerComponent = (props: ExtraFeaturesDrawerProps) => {
	useEffect(() => {
		if (props.openDrawerToSeeDescription) {
			emitMoeEvent('Info Bottomsheet Opened', {
				heading: props?.data?.label,
			});
		}
	}, [props.openDrawerToSeeDescription]);

	return (
		<Drawer
			anchor='right'
			open={props.openDrawerToSeeDescription}
			onClose={props.setOpenExtraFeatureDrawer}
		>
			<FlexBox direction='column' sx={{ padding: '80px', width: '600px' }}>
				<FlexBox
					sx={{ justifyContent: 'space-between', paddingBottom: '40px' }}
				>
					<Box>{props.icon}</Box>
					<Box
						onClick={props.setOpenExtraFeatureDrawer}
						sx={{ cursor: 'pointer' }}
					>
						<CrossIcon />
					</Box>
				</FlexBox>
				<Box
					sx={{
						...getStyle('H14_SemiBold'),
						color: getColor('Gray -1'),
						paddingBottom: '30px',
					}}
					dangerouslySetInnerHTML={{ __html: props?.data?.label }}
				/>
				<Box
					sx={{
						h2: {
							...getStyle('P_Medium'),
							color: getColor('Gray 0'),
							paddingBottom: '8px',
						},

						// 'p > span:nth-of-type(1)': {
						// 	...getStyle('H14_Medium'),
						// 	color: getColor('Gray 0'),
						// },
						p: {
							...getStyle('P_Regular'),
							color: getColor('Gray -2'),
							paddingBottom: '16px',
						},
					}}
					dangerouslySetInnerHTML={{ __html: props?.data?.description }}
				/>
			</FlexBox>
		</Drawer>
	);
};

export default ExtraFeaturesDrawerComponent;
